import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import d3 from 'd3'
import i18n from './i18n'


// var debug = false
var debug = false

var domainURL = "https://selector.ferat.com.tr";
var port = ""
if (debug){
  domainURL = "http://localhost";
  port = ":9090"
}



Vue.prototype.$API_URL = domainURL+port+"/api/";
Vue.prototype.$DOMAIN_URL = domainURL; 
// Vue.prototype.$DOMAIN_URL = domainURL+"/"; 


Vue.prototype.$DEVELOPER_URL = "https://yazilimsalcozumler.com/api/pumpselection/";

Vue.config.productionTip = !debug
Vue.prototype.$http = axios

window.myvue = new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
